import { connect } from 'react-redux';
import ASQSidebar from '../../components/asq/ASQSidebar';

const mapStateToProps = (state) => {
  return {
    survey: state.survey.survey,
  }
}

const ASQSidebarContainer = connect(
  mapStateToProps,
  null
)(ASQSidebar)

export default ASQSidebarContainer;
